import tw from 'twin.macro';
import { css } from '@emotion/react';
import { PageInfo } from '../graphql-types';
import React from 'react';
import { ArticleItem } from '../components/article';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { Link, navigate } from 'gatsby';
import { Pagination } from '../components/pagination';
import SearchForm from './search-form';

interface ArticleListState {
  query?: string;
  page?: number;
}

interface ArticleListProps {
  pageInfo: PageInfo;
  articles: any[];
  popularArticles: any[];
  category?: string;
  tagTitle?: string;
  tags?: any[];
}

class ArticleList extends React.Component<ArticleListProps, ArticleListState> {
  constructor(props: ArticleListProps) {
    super(props);
    this.state = { query: '' };
  }

  generateRoute(category) {
    if (category === 'Perizinan Berusaha') {
      return 'category/perizinan-berusaha';
    } else if (category === 'Badan Usaha') {
      return 'category/badan-usaha';
    } else if (category === 'Pajak Perusahaan') {
      return 'category/pajak-perusahaan';
    } else {
      return 'artikel';
    }
  }

  handleSearch(query: string) {
    navigate(`/search/?query=${query ?? ''}`);
  }

  render() {
    const pageInfo = this.props.pageInfo;
    const category = this.props.category;
    const articles = this.props.articles;

    const popularArticles = this.props.popularArticles;

    const tags = this.props.tags;

    const categories = ['Artikel Terbaru', 'Perizinan Berusaha', 'Badan Usaha', 'Pajak Perusahaan'];

    return (
      <div>
        <section tw="bg-blue-marine dark:bg-blue-black">
          <div tw="container">
            <div tw="mx-8 lg:mx-32 pt-24 pb-12">
              <h1 tw="text-white py-4 m-0">Artikel by Easybiz</h1>
              <p tw="text-b1 text-white">
                Temukan artikel sebagai solusi yang jitu untuk masalah Anda
              </p>
              <SearchForm query={this.state?.query} onSubmit={query => this.handleSearch(query)} />
            </div>
          </div>
        </section>
        <section tw="bg-white dark:bg-black-200">
          <div tw="container">
            <div tw="mx-8 lg:mx-32 py-12">
              <h2 tw="text-black-100 dark:text-white pb-4 m-0">Artikel Populer</h2>
              <div tw="grid grid-cols-1 lg:grid-cols-3 lg:gap-4 py-4">
                {popularArticles.map((item, i) => (
                  <ArticleItem
                    key={'populararticle' + i}
                    title={item.title}
                    date={item.date}
                    info={item.info}
                    img={item.img?.fluid}
                    link={item.uid}
                    category={item.category}
                  >
                    {documentToReactComponents(JSON.parse(item.shortDescription?.raw))}
                  </ArticleItem>
                ))}
              </div>
            </div>
          </div>
        </section>
        <div
          css={css`
            border-bottom: 1px solid;
            ${tw`border-black-300`}
          `}
        ></div>
        <section tw="bg-white dark:bg-black-200">
          <div tw="container">
            <div tw="mx-8 lg:mx-32 py-12">
              <div tw="grid grid-cols-1 lg:grid-cols-3 lg:gap-4 py-4">
                <div tw="lg:col-span-2">
                  <h2 tw="text-black-100 dark:text-white pb-8 m-0" id="article-list">
                    Cari Berdasarkan <b tw="text-blue-lapis">Kategori</b>
                  </h2>
                  <div tw="mb-8">
                    <div
                      css={css`
                        position: relative;
                        top: 37px;
                      `}
                    ></div>
                    <div
                      tw="flex flex-wrap"
                      css={css`
                        position: relative;
                        top: -2px;
                      `}
                    >
                      <div
                        css={css`
                          @media (min-width: 1024px) {
                            border-bottom: solid 1px #181d2a;
                            bottom: 0px;
                            position: absolute;
                            width: 100%;
                            z-index: 1;
                          }
                        `}
                      ></div>
                      {categories.map((item, i) => (
                        <Link
                          className="gtm-article-category"
                          key={'categories' + i}
                          tw="bg-blue-sky rounded-lg py-2 px-2 mr-2 cursor-pointer no-underline"
                          css={css`
                            ${category === item ? 'font-weight: 800;' : ''}
                            ${category === item
                              ? tw`text-black-100 visited:text-black-100`
                              : tw`text-blue-marine visited:text-blue-marine`}
                            ${category === item ? tw`bg-white` : ''}
                            ${category === item ? 'border: solid 1px #181d2a;' : ''}
                            ${tw`mb-2`}
                            z-index: 2;
                            @media (min-width: 1024px) {
                              ${tw`rounded-none`}
                              ${tw`rounded-t-lg`}
                              ${tw`mb-0`}
                              ${category === item
                                ? 'border-bottom: solid 1px white;'
                                : 'border-bottom: solid 1px #181d2a;'}
                            }
                          `}
                          to={`/${this.generateRoute(item)}#article-list`}
                        >
                          {item}
                        </Link>
                      ))}
                    </div>
                  </div>
                  {articles.map((item, i) => (
                    item.shortDescription?.raw ? 
                    <ArticleItem
                      key={'article' + i}
                      title={item.title}
                      date={item.date}
                      info={item.info}
                      img={item.img?.fluid}
                      link={item.uid}
                      category={item.category}
                      imgHeight={200}
                    >
                      {documentToReactComponents(JSON.parse(item.shortDescription?.raw))}
                    </ArticleItem> : <div></div>
                  ))}
                  <Pagination
                    pageContext={pageInfo}
                    route={`${this.generateRoute(category)}`}
                    pageRoute={'page'}
                  ></Pagination>
                </div>
                <div>
                  <span tw="text-b1 dark:text-white">{this.props.tagTitle}</span>
                  <div tw="mt-3 flex flex-wrap mb-3">
                    {tags
                      .filter(item => item.popular)
                      .map((item, i) => (
                        <Link
                          className="gtm-article-tag"
                          key={'tags' + i}
                          tw="bg-black-700 rounded-lg py-2 px-2 mr-2 mb-3 cursor-pointer no-underline text-black-100 visited:text-black-100"
                          to={`/tag/${
                            item.title.replace(new RegExp(' ', 'g'), '-').toLowerCase() + '/' ?? ''
                          }`}
                        >
                          {item.title}
                        </Link>
                      ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default ArticleList;
